export const Config = {
  maxItems: 5,
  portalType: 'InfoEvent',
  reviewState: 'published',
  sortOn: 'start',
  depth: '1',
};
